import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Particles } from './Particles';
export const Hero = () => {
  const text1 = 'Instagram puede desaparecer mañana.';
  const text2 = '¿Tu negocio también?';
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.5
      }
    }
  };
  const charVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-background via-[#050510] to-background pt-20" data-id="element-66">
      <Particles data-id="element-67" />

      <div className="container mx-auto px-6 relative z-10 text-center flex flex-col items-center -mt-16 md:-mt-24" data-id="element-68">
        <motion.div className="mb-8 min-h-[120px] md:min-h-[160px] flex flex-col items-center justify-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-69">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-70">
            {text1.split('').map((char, index) => <motion.span key={`t1-${index}`} variants={charVariants} data-id="element-71">
                {char}
              </motion.span>)}
          </h1>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-primary leading-tight" data-id="element-72">
            {text2.split('').map((char, index) => <motion.span key={`t2-${index}`} variants={charVariants} data-id="element-73">
                {char}
              </motion.span>)}
          </h2>
        </motion.div>

        <motion.p className="text-lg md:text-xl text-text-secondary max-w-2xl mx-auto mb-12 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 2.5,
        duration: 1
      }} data-id="element-74">
          Meta elimina cuentas todos los días sin previo aviso y sin darte
          ninguna explicación. Un día tenés miles de seguidores, al otro día no
          tenés nada.
          <br className="hidden md:block" data-id="element-75" />
          <br className="hidden md:block" data-id="element-76" />
          <span className="text-white font-semibold block mt-4" data-id="element-77">
            Tu página web no le pertenece a nadie más que a vos.
          </span>
        </motion.p>

        <motion.button className="relative group overflow-hidden bg-primary text-background font-bold text-sm md:text-base tracking-widest py-4 px-8 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-all duration-300 shimmer" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 3,
        duration: 0.5
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => document.getElementById('revelation')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-78">
          ✦ QUIERO SABER MÁS ✦
        </motion.button>
      </div>
    </section>;
};